<template>
  <div class="ts-h-full">
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-12 ts-flex ts-items-center ts-justify-center">
          <ts-image-input
            :file="model.photo ? model.photo : file"
            @input="file => (model.photo = file)"
            :width="250"
            :height="200"
            crop
          ></ts-image-input>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { debounce } from 'lodash'
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'photo',
  props: ['value', 'validate'],
  data() {
    return {
      show_list: false,
      loading: false,
      search: null,
      location_list: [],
      errors: new Errors(),
      file: require('@/assets/default-product_flat.jpg'),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  methods: {
    ...mapActions('product/profile', ['getLocationStorage']),
    showList() {
      this.show_list = true
      this.fetchLocation()
    },
    fetchLocation() {
      this.loading = true
      this.getLocationStorage({
        filter: {
          search: this.search
        }
      })
        .then(response => {
          this.location_list = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    changeLocation(e) {
      const id = e.target.value
      this.model.warehouse_storage_name = this.location_list.find(
        l => l.warehouse_storage_id == id
      ).storage_name_en
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    },
    search: debounce(function(search) {
      this.fetchLocation()
    }, 500)
  }
}
</script>
